<template>
  <div>
    <h3>Cashback</h3>
    <p>CASHBACK - programme de remboursement d’argent bonus pour une série négative.</p>
    <h5>Règles et conditions</h5>
    <ol>
        <li>Le bonus Cashback est crédité sur le compte tous les {{bonus.days}} jours.</li>
        <li>Le bonus Cashback est égal à {{bonus.percent || 0}}% du montant perdu au cours des {{bonus.days}} derniers jours.</li>
        <li>Prochaine imputation aura lieu le {{formatDate(bonus.nextDate)}}.</li>
        <li>Pour le calcul du bonus, seules les mises effectuées dans la rubrique " Casino " du site sont prises en compte.</li>
        <li>Les règles de promotion sont sujettes à changement.</li>
    </ol>
  </div>
</template>
<script>
  import utils from '../../../../../../../_common/utils'

  export default {
    name: 'bonus-rules-cashback-fr',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatDate(date) {
        return utils.formatDateTime(date, 'MM/DD HH:mm');
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-cashback/fr.vue